<template>
  <Component
    class="ui-button-icon"
    :class="[
      `styled-${styled}`,
      {
        'is-disabled': disabled,
      }
    ]"
    :is="tag"
    :type="type"
    :disabled="disabled"
  >
    <BaseIcon
      :name="icon"
      :alt="arialabel"
      :class="innerClass"
      :size="iconSize"
      :is-spin="isSpin"
      class="ui-button-icon-background"
    />
  </Component>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'
interface Props {
  tag?: string
  type?: 'submit' | 'button' | 'reset'
  icon: SVG_NAMES
  iconSize?: `size-${number}` | 'size-full' | 'size-none'
  arialabel?: string
  innerClass?: string
  isSpin?: boolean
  styled?: 'primary' | 'secondary'
  disabled?: boolean
}
withDefaults(defineProps<Props>(), {
  tag: 'button',
  type: 'button',
  size: 'medium',
  innerClass: '',
  isSpin: false,
  styled: 'primary',
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

button,
a {
  cursor: pointer;
}

.ui-button-icon {
  line-height: 0;
  // リスト削除ボタンの余白を縮める
  //padding: 0.25rem;
  padding: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: max-content;
  width: max-content;

  // NOTE: スタイルを上書きしている箇所があるため、初期値である styled = primary のカラー定義は複合セレクタにしない。
  color: $jps-key-blue;
  &:hover {
    color: $jps-key-blue-hover;
  }

  &.styled-secondary {
    color: $jps-gray-600;

    &:hover {
      color: $jps-gray-900;
    }
  }

  &:focus, &:active {
    outline: 1px solid $jps-key-blue-hover;
    border-radius: 100%;  // ここでフォーカスラウンドになる
  }

  &.is-disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
.ui-button-icon-background {
//  background-color: transparent;
}
</style>
